import * as N from "react";
import Fe, { Children as xe, isValidElement as H, cloneElement as W, useCallback as de, useRef as X, useEffect as B, useState as $e } from "react";
import { useTimeout as je, useUnmountEffect as Ue, Portal as He, Ripple as We, PrimeReact as ne } from "./portal.esm.79076359.js";
import { _inheritsLoose as ze, _extends as qe, _objectWithoutPropertiesLoose as Ze, TransitionGroupContext as ae, CSSTransition as Ge } from "./csstransition.esm.5346b5f2.js";
import { jsx as g, classNames as z, jsxs as $, DomHandler as ie, ObjectUtils as me, Fragment as Ve, ZIndexUtils as j } from "./utils.esm.ea524c19.js";
import { propTypes as I } from "./index.dcccd5e7.js";
function Qe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ee(e, t) {
  var r = function(o) {
    return t && H(o) ? t(o) : o;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && xe.map(e, function(a) {
    return a;
  }).forEach(function(a) {
    n[a.key] = r(a);
  }), n;
}
function Be(e, t) {
  e = e || {}, t = t || {};
  function r(m) {
    return m in t ? t[m] : e[m];
  }
  var n = /* @__PURE__ */ Object.create(null), a = [];
  for (var o in e)
    o in t ? a.length && (n[o] = a, a = []) : a.push(o);
  var i, u = {};
  for (var l in t) {
    if (n[l])
      for (i = 0; i < n[l].length; i++) {
        var f = n[l][i];
        u[n[l][i]] = r(f);
      }
    u[l] = r(l);
  }
  for (i = 0; i < a.length; i++)
    u[a[i]] = r(a[i]);
  return u;
}
function R(e, t, r) {
  return r[t] != null ? r[t] : e.props[t];
}
function Je(e, t) {
  return ee(e.children, function(r) {
    return W(r, {
      onExited: t.bind(null, r),
      in: !0,
      appear: R(r, "appear", e),
      enter: R(r, "enter", e),
      exit: R(r, "exit", e)
    });
  });
}
function Ye(e, t, r) {
  var n = ee(e.children), a = Be(t, n);
  return Object.keys(a).forEach(function(o) {
    var i = a[o];
    if (!!H(i)) {
      var u = o in t, l = o in n, f = t[o], m = H(f) && !f.props.in;
      l && (!u || m) ? a[o] = W(i, {
        onExited: r.bind(null, i),
        in: !0,
        exit: R(i, "exit", e),
        enter: R(i, "enter", e)
      }) : !l && u && !m ? a[o] = W(i, {
        in: !1
      }) : l && u && H(f) && (a[o] = W(i, {
        onExited: r.bind(null, i),
        in: f.props.in,
        exit: R(i, "exit", e),
        enter: R(i, "enter", e)
      }));
    }
  }), a;
}
var Ke = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, ke = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, te = /* @__PURE__ */ function(e) {
  ze(t, e);
  function t(n, a) {
    var o;
    o = e.call(this, n, a) || this;
    var i = o.handleExited.bind(Qe(o));
    return o.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: i,
      firstRender: !0
    }, o;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(a, o) {
    var i = o.children, u = o.handleExited, l = o.firstRender;
    return {
      children: l ? Je(a, u) : Ye(a, i, u),
      firstRender: !1
    };
  }, r.handleExited = function(a, o) {
    var i = ee(this.props.children);
    a.key in i || (a.props.onExited && a.props.onExited(o), this.mounted && this.setState(function(u) {
      var l = qe({}, u.children);
      return delete l[a.key], {
        children: l
      };
    }));
  }, r.render = function() {
    var a = this.props, o = a.component, i = a.childFactory, u = Ze(a, ["component", "childFactory"]), l = this.state.contextValue, f = Ke(this.state.children).map(i);
    return delete u.appear, delete u.enter, delete u.exit, o === null ? /* @__PURE__ */ g(ae.Provider, {
      value: l,
      children: f
    }) : /* @__PURE__ */ g(ae.Provider, {
      value: l,
      children: /* @__PURE__ */ g(o, {
        ...u,
        children: f
      })
    });
  }, t;
}(Fe.Component);
te.propTypes = process.env.NODE_ENV !== "production" ? {
  component: I.exports.any,
  children: I.exports.node,
  appear: I.exports.bool,
  enter: I.exports.bool,
  exit: I.exports.bool,
  childFactory: I.exports.func
} : {};
te.defaultProps = ke;
const Xe = te, oe = "Sorry but something went wrong", et = "The resource you were looking for could not be found.", tt = "You don't have permission to do this request.", U = "Please contact your BW Event Technology Project manager or onsite staff member for help with this issue.", rt = process.env.REACT_APP_BACKEND_URL || "", nt = ({
  messenger: e,
  onError: t,
  onForbidden: r,
  onLogout: n,
  onNotFound: a,
  setIsLoading: o
}) => de((i, {
  method: u = "GET",
  body: l = {},
  headers: f = {},
  timeout: m = 1e4,
  hideSuccessMessages: _ = !1,
  ignoreForbidden: O = !1,
  ignoreNotFound: M = !1,
  ignoreError: P = !1,
  ignoreIsLoading: E = !1
} = {}) => {
  typeof o == "function" && E !== !0 && o(!0), l instanceof FormData || (l = JSON.stringify(l), f = {
    "Content-Type": "application/json",
    ...f
  });
  const C = new AbortController();
  return setTimeout(() => C.abort(), m), fetch(`${rt}/${i}`, {
    method: u.toUpperCase(),
    mode: "cors",
    signal: C.signal,
    credentials: "include",
    referrerPolicy: "origin",
    headers: f,
    body: ["GET", "HEAD"].includes(u.toUpperCase()) ? void 0 : l
  }).then(async (c) => {
    var h;
    const s = (h = c.headers.get("content-disposition")) != null && h.startsWith("attachment") ? await c.blob().catch(() => null) : await c.json().catch(() => null);
    let v = !1;
    if (Array.isArray(s == null ? void 0 : s.messages))
      for (const d of s.messages)
        d.level === "debug" ? console.debug(...[d.title, d.description].filter((w) => w)) : (v || (v = d.level === "error"), typeof e == "function" && !(d.level === "success" && _) && e({
          severity: d.level,
          summary: d.title,
          detail: d.description,
          life: d.duration || (d.level === "error" ? 5e3 : 3e3)
        }));
    return c.ok || (c.status === 401 ? typeof n == "function" && n() : c.status === 403 ? O || (typeof r == "function" && r(), v || typeof e == "function" && e({
      severity: "error",
      summary: tt,
      detail: U,
      life: 5e3
    })) : c.status === 404 ? M || (typeof a == "function" && a(), v || typeof e == "function" && e({
      severity: "error",
      summary: et,
      detail: U,
      life: 5e3
    })) : P || (typeof t == "function" && t(), v || typeof e == "function" && e({
      severity: "error",
      summary: oe,
      detail: U,
      life: 5e3
    }))), typeof o == "function" && E !== !0 && o(!1), {
      ok: c.ok,
      body: s
    };
  }).catch((c) => (console.error(c), typeof e == "function" && e({
    severity: "error",
    summary: oe,
    detail: U,
    life: 5e3
  }), typeof o == "function" && E !== !0 && o(!1), {
    ok: !1,
    body: void 0
  }));
}, [e, t, r, n, a, o]);
function J(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function at(e) {
  if (Array.isArray(e))
    return J(e);
}
function it(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ve(e, t) {
  if (!!e) {
    if (typeof e == "string")
      return J(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return J(e, t);
  }
}
function ot() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Q(e) {
  return at(e) || it(e) || ve(e) || ot();
}
function ut(e) {
  if (Array.isArray(e))
    return e;
}
function lt(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, o = !1, i, u;
    try {
      for (r = r.call(e); !(a = (i = r.next()).done) && (n.push(i.value), !(t && n.length === t)); a = !0)
        ;
    } catch (l) {
      o = !0, u = l;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (o)
          throw u;
      }
    }
    return n;
  }
}
function st() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y(e, t) {
  return ut(e) || lt(e, t) || ve(e, t) || st();
}
function S(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function ue(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function ct(e, t, r) {
  return t && ue(e.prototype, t), r && ue(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ft(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var p = Object.freeze({
  STARTS_WITH: "startsWith",
  CONTAINS: "contains",
  NOT_CONTAINS: "notContains",
  ENDS_WITH: "endsWith",
  EQUALS: "equals",
  NOT_EQUALS: "notEquals",
  IN: "in",
  LESS_THAN: "lt",
  LESS_THAN_OR_EQUAL_TO: "lte",
  GREATER_THAN: "gt",
  GREATER_THAN_OR_EQUAL_TO: "gte",
  BETWEEN: "between",
  DATE_IS: "dateIs",
  DATE_IS_NOT: "dateIsNot",
  DATE_BEFORE: "dateBefore",
  DATE_AFTER: "dateAfter",
  CUSTOM: "custom"
}), T = /* @__PURE__ */ ct(function e() {
  ft(this, e);
});
S(T, "ripple", !1);
S(T, "inputStyle", "outlined");
S(T, "locale", "en");
S(T, "appendTo", null);
S(T, "cssTransition", !0);
S(T, "autoZIndex", !0);
S(T, "nonce", null);
S(T, "nullSortOrder", 1);
S(T, "zIndex", {
  modal: 1100,
  overlay: 1e3,
  menu: 1e3,
  tooltip: 1100,
  toast: 1200
});
S(T, "filterMatchModeOptions", {
  text: [p.STARTS_WITH, p.CONTAINS, p.NOT_CONTAINS, p.ENDS_WITH, p.EQUALS, p.NOT_EQUALS],
  numeric: [p.EQUALS, p.NOT_EQUALS, p.LESS_THAN, p.LESS_THAN_OR_EQUAL_TO, p.GREATER_THAN, p.GREATER_THAN_OR_EQUAL_TO],
  date: [p.DATE_IS, p.DATE_IS_NOT, p.DATE_BEFORE, p.DATE_AFTER]
});
var dt = {
  en: {
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    filter: "Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    custom: "Custom",
    clear: "Clear",
    close: "Close",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    dateFormat: "mm/dd/yy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No available options",
    emptyMessage: "No results found",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "Not Selected",
      pageLabel: "Page",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page",
      nextPageLabel: "Next Page",
      previousPageLabel: "Previous Page",
      selectLabel: "Select",
      unselectLabel: "Unselect",
      expandLabel: "Expand",
      collapseLabel: "Collapse"
    }
  }
};
function mt(e, t) {
  var r = t || T.locale;
  try {
    return vt(r)[e];
  } catch {
    throw new Error("The ".concat(e, " option is not found in the current locale('").concat(r, "')."));
  }
}
function vt(e) {
  var t = e || T.locale;
  return dt[t];
}
var pe = /* @__PURE__ */ N.memo(/* @__PURE__ */ N.forwardRef(function(e, t) {
  var r = e.messageInfo, n = r.message, a = n.severity, o = n.content, i = n.summary, u = n.detail, l = n.closable, f = n.life, m = n.sticky, _ = n.className, O = n.style, M = n.contentClassName, P = n.contentStyle, E = N.useState(!1), C = Y(E, 2), c = C[0], s = C[1], v = je(function() {
    w();
  }, f || 3e3, !m && !c), h = Y(v, 1), d = h[0], w = function() {
    d(), e.onClose && e.onClose(r);
  }, F = function(A) {
    e.onClick && !(ie.hasClass(A.target, "p-toast-icon-close") || ie.hasClass(A.target, "p-toast-icon-close-icon")) && e.onClick(r.message);
  }, V = function(A) {
    e.onMouseEnter && e.onMouseEnter(A), !A.defaultPrevented && (m || (d(), s(!0)));
  }, we = function(A) {
    e.onMouseLeave && e.onMouseLeave(A), !A.defaultPrevented && (m || s(!1));
  }, Ne = function() {
    return l !== !1 ? /* @__PURE__ */ g("div", {
      children: /* @__PURE__ */ $("button", {
        type: "button",
        className: "p-toast-icon-close p-link",
        onClick: w,
        "aria-label": mt("close"),
        children: [/* @__PURE__ */ g("span", {
          className: "p-toast-icon-close-icon pi pi-times",
          "aria-hidden": "true"
        }), /* @__PURE__ */ g(We, {})]
      })
    }) : null;
  }, Me = function() {
    if (r) {
      var A = me.getJSXElement(o, {
        message: r.message,
        onClick: F,
        onClose: w
      }), Ie = z("p-toast-message-icon pi", {
        "pi-info-circle": a === "info",
        "pi-exclamation-triangle": a === "warn",
        "pi-times": a === "error",
        "pi-check": a === "success"
      });
      return A || /* @__PURE__ */ $(Ve, {
        children: [/* @__PURE__ */ g("span", {
          className: Ie
        }), /* @__PURE__ */ $("div", {
          className: "p-toast-message-text",
          children: [/* @__PURE__ */ g("span", {
            className: "p-toast-summary",
            children: i
          }), u && /* @__PURE__ */ g("div", {
            className: "p-toast-detail",
            children: u
          })]
        })]
      });
    }
    return null;
  }, Pe = z("p-toast-message", S({}, "p-toast-message-".concat(a), a), _), De = z("p-toast-message-content", M), Re = Me(), Le = Ne();
  return /* @__PURE__ */ g("div", {
    ref: t,
    className: Pe,
    style: O,
    role: "alert",
    "aria-live": "assertive",
    "aria-atomic": "true",
    onClick: F,
    onMouseEnter: V,
    onMouseLeave: we,
    children: /* @__PURE__ */ $("div", {
      className: De,
      style: P,
      children: [Re, Le]
    })
  });
}));
pe.displayName = "ToastMessage";
var le = 0, Z = /* @__PURE__ */ N.memo(/* @__PURE__ */ N.forwardRef(function(e, t) {
  var r = N.useState([]), n = Y(r, 2), a = n[0], o = n[1], i = N.useRef(null), u = function(s) {
    if (s) {
      var v = l(s, !0);
      a.length === 0 && j.set("toast", i.current, ne.autoZIndex, e.baseZIndex || ne.zIndex.toast), o(v);
    }
  }, l = function(s, v) {
    var h;
    if (Array.isArray(s)) {
      var d = s.reduce(function(F, V) {
        return F.push({
          _pId: le++,
          message: V
        }), F;
      }, []);
      v ? h = a ? [].concat(Q(a), Q(d)) : d : h = d;
    } else {
      var w = {
        _pId: le++,
        message: s
      };
      v ? h = a ? [].concat(Q(a), [w]) : [w] : h = [w];
    }
    return h;
  }, f = function() {
    j.clear(i.current), o([]);
  }, m = function(s) {
    var v = l(s, !1);
    o(v);
  }, _ = function(s) {
    var v = a.filter(function(h) {
      return h._pId !== s._pId;
    });
    o(v), e.onRemove && e.onRemove(s.message);
  }, O = function(s) {
    _(s);
  }, M = function() {
    e.onShow && e.onShow();
  }, P = function() {
    a.length === 1 && j.clear(i.current), e.onHide && e.onHide();
  };
  Ue(function() {
    j.clear(i.current);
  }), N.useImperativeHandle(t, function() {
    return {
      props: e,
      show: u,
      replace: m,
      remove: _,
      clear: f,
      getElement: function() {
        return i.current;
      }
    };
  });
  var E = function() {
    var s = me.findDiffKeys(e, Z.defaultProps), v = z("p-toast p-component p-toast-" + e.position, e.className);
    return /* @__PURE__ */ g("div", {
      ref: i,
      id: e.id,
      className: v,
      style: e.style,
      ...s,
      children: /* @__PURE__ */ g(Xe, {
        children: a.map(function(h) {
          var d = /* @__PURE__ */ N.createRef();
          return /* @__PURE__ */ g(Ge, {
            nodeRef: d,
            classNames: "p-toast-message",
            unmountOnExit: !0,
            timeout: {
              enter: 300,
              exit: 300
            },
            onEntered: M,
            onExited: P,
            options: e.transitionOptions,
            children: /* @__PURE__ */ g(pe, {
              ref: d,
              messageInfo: h,
              onClick: e.onClick,
              onClose: O,
              onMouseEnter: e.onMouseEnter,
              onMouseLeave: e.onMouseLeave
            })
          }, h._pId);
        })
      })
    });
  }, C = E();
  return /* @__PURE__ */ g(He, {
    element: C,
    appendTo: e.appendTo
  });
}));
Z.displayName = "Toast";
Z.defaultProps = {
  __TYPE: "Toast",
  id: null,
  className: null,
  style: null,
  baseZIndex: 0,
  position: "top-right",
  transitionOptions: null,
  appendTo: "self",
  onClick: null,
  onRemove: null,
  onShow: null,
  onHide: null,
  onMouseEnter: null,
  onMouseLeave: null
};
const pt = () => {
  const e = X();
  return {
    messenger: de(({
      severity: n,
      summary: a,
      detail: o,
      life: i = 3e3
    }) => {
      var u;
      (u = e.current) == null || u.show({
        severity: n,
        summary: a,
        detail: o,
        life: i
      });
    }, [e]),
    messengerNode: /* @__PURE__ */ g(Z, {
      ref: e
    })
  };
};
var ge = {}, y = {};
Object.defineProperty(y, "__esModule", {
  value: !0
});
y.includesKeyValue = _t;
y.isColorDark = Tt;
y.isColorLight = bt;
y.isDict = yt;
y.isEmpty = he;
y.isEqual = q;
y.isNotEmpty = ht;
y.isNotEqual = gt;
y.isString = St;
y.isValidEmail = At;
y.isValidPhone = Ct;
function q(e, t) {
  if ((e == null ? void 0 : e.__proto__) !== (t == null ? void 0 : t.__proto__))
    return !1;
  if (Array.isArray(e)) {
    if (e.length !== t.length)
      return !1;
    for (var r in e)
      if (!q(e[r], t[r]))
        return !1;
    return !0;
  }
  if (e instanceof Object && typeof e != "function") {
    if (Object.keys(e).filter(function(a) {
      return e[a] !== void 0;
    }).sort().toString() !== Object.keys(t).filter(function(a) {
      return t[a] !== void 0;
    }).sort().toString())
      return !1;
    for (var n in e)
      if (!q(e[n], t[n]))
        return !1;
    return !0;
  }
  return e === t;
}
function gt(e, t) {
  return !q(e, t);
}
function he(e) {
  for (var t in e)
    return !1;
  return !0;
}
function ht(e) {
  return !he(e);
}
function yt(e) {
  return (e == null ? void 0 : e.__proto__) === {}.__proto__;
}
function _t(e, t, r) {
  return Array.isArray(e) ? e.some(function(n) {
    return (n == null ? void 0 : n[t]) === r;
  }) : !1;
}
var ye = new RegExp("^#[0-9A-f]{6}$");
function _e(e) {
  var t = function(u) {
    return u = u / 255, u <= 0.03928 ? u / 12.92 : Math.pow((u + 0.055) / 1.055, 2.4);
  }, r = t(parseInt(e.substr(1, 2), 16)), n = t(parseInt(e.substr(3, 2), 16)), a = t(parseInt(e.substr(5, 2), 16)), o = 0.2126 * r + 0.7152 * n + 0.0722 * a;
  return o > 0.3;
}
function bt(e) {
  if (!!ye.test(e))
    return _e(e);
}
function Tt(e) {
  if (!!ye.test(e))
    return !_e(e);
}
function St(e) {
  return typeof e == "string" || e instanceof String;
}
var Et = new RegExp("^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$");
function At(e) {
  return Et.test(e);
}
var Ot = new RegExp("^(\\+[1-9]\\d?[\\s.-]?)?(\\(\\d{3}\\)|\\d{3})[\\s.-]?\\d{3,4}[\\s.-]?\\d{4,5}$");
function Ct(e) {
  return Ot.test(e);
}
var b = {};
Object.defineProperty(b, "__esModule", {
  value: !0
});
b.capitalizeString = Ee;
b.dateToString = Dt;
b.datetimeToString = Pt;
b.mappingKeyToString = xt;
b.momentLocalTimeFormat = b.momentLocalDateFormat = void 0;
b.numberToString = Nt;
b.timeToString = Rt;
var be = y;
function se(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function D(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? se(Object(r), !0).forEach(function(n) {
      wt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : se(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wt(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Nt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (!["", null, void 0].includes(e)) {
    var n = Number(e);
    if (!t && Number.isInteger(n))
      return (r ? "$" : "") + n.toLocaleString();
    if (Number.isFinite(n))
      return (r ? "$" : "") + n.toLocaleString(void 0, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
  }
  return "-";
}
var Te = {
  hour: "2-digit",
  minute: "2-digit"
}, Se = function(t) {
  return {
    day: "2-digit",
    month: t ? "2-digit" : "long",
    year: "numeric"
  };
}, Mt = Intl.DateTimeFormat().resolvedOptions().timeZone;
function Pt(e, t) {
  var r = t || {}, n = r.short, a = n === void 0 ? !1 : n, o = r.showDate, i = o === void 0 ? !0 : o, u = r.showTime, l = u === void 0 ? !0 : u, f = r.timezone, m = f === void 0 ? null : f;
  if (!e)
    return "-";
  var _ = new Date(e), O = {}, M = "";
  if (m) {
    var P = new Date(_.toLocaleString("en-US", {
      timeZone: "UTC"
    })), E = (new Date(_.toLocaleString("en-US", {
      timeZone: m
    })) - P) / 60 / 60 / 1e3, C = (new Date(_.toLocaleString("en-US", {
      timeZone: Mt
    })) - P) / 60 / 60 / 1e3;
    E != C && (O.timeZone = m, M = " GMT".concat(E.toFixed(2)));
  }
  return (i ? _.toLocaleString([], D(D({}, Se(a)), O)) : "") + (i && l ? " @ " : "") + (l ? _.toLocaleString([], D(D({}, Te), O)) : "") + (l ? M : "");
}
function Dt(e, t) {
  var r = t || {}, n = r.short, a = n === void 0 ? !1 : n;
  return e ? new Date(e).toLocaleString([], D(D({}, Se(a)), {}, {
    timeZone: "UTC"
  })) : "-";
}
function Rt(e) {
  if (!e)
    return "-";
  var t = new Date(e);
  return !t.valueOf() && (t = new Date("2000-01-01T".concat(e, "Z")), !t.valueOf()) ? "-" : t.toLocaleString([], D(D({}, Te), {}, {
    timeZone: "UTC"
  }));
}
var Lt = new Date("2000-11-12T13:14Z"), It = Lt.toLocaleDateString([], {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "UTC"
}).replace("2000", "YYYY").replace("11", "MM").replace("12", "DD");
b.momentLocalDateFormat = It;
var Ft = Intl.DateTimeFormat([], {
  hour: "numeric"
}).resolvedOptions().hourCycle === "h12" ? "hh:mm A" : "HH:mm";
b.momentLocalTimeFormat = Ft;
function Ee(e) {
  return (0, be.isString)(e) ? e.toLowerCase().replace(/(^\w)|(\s\w)/g, function(t) {
    return t.toUpperCase();
  }) : "";
}
function xt(e) {
  return (0, be.isString)(e) ? Ee(e.replace(/-|_|(?=[A-Z])/g, " ")) : "";
}
var re = {};
Object.defineProperty(re, "__esModule", {
  value: !0
});
re.copyDeep = Ae;
function Ae(e) {
  var t;
  if (e instanceof Object && !(e instanceof File) && typeof e != "function") {
    Array.isArray(e) ? t = [] : t = {};
    for (var r in e)
      t[r] = Ae(e[r]);
  } else
    t = e;
  return t;
}
var G = {};
Object.defineProperty(G, "__esModule", {
  value: !0
});
G.sortArrayByKey = zt;
G.sortValues = Oe;
function $t(e) {
  return Wt(e) || Ht(e) || Ut(e) || jt();
}
function jt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ut(e, t) {
  if (!!e) {
    if (typeof e == "string")
      return K(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return K(e, t);
  }
}
function Ht(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Wt(e) {
  if (Array.isArray(e))
    return K(e);
}
function K(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Oe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "label";
  return function(t, r) {
    var n = t == null ? void 0 : t[e], a = r == null ? void 0 : r[e];
    return typeof n == "string" && (n = n.toUpperCase()), typeof a == "string" && (a = a.toUpperCase()), n > a ? 1 : n < a ? -1 : 0;
  };
}
function zt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "label";
  return Array.isArray(e) ? $t(e).sort(Oe(t)) : [];
}
var L = {};
Object.defineProperty(L, "__esModule", {
  value: !0
});
L.getRandomColor = Gt;
L.getUniqueName = k;
L.getUniqueOption = Vt;
L.range = Qt;
L.roundAndTruncate = Bt;
var qt = y;
function ce(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function fe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ce(Object(r), !0).forEach(function(n) {
      Zt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ce(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Zt(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Gt() {
  return "#" + ("000000" + Math.floor(Math.random() * 16777215).toString(16)).substr(-6);
}
function k(e, t) {
  if (!Array.isArray(t) || !(0, qt.isString)(e)) {
    console.error("Can't get an unique name to", e, "from", t);
    return;
  }
  if (!t.includes(e))
    return e;
  for (var r = e.replace(/_[0-9]+$/, ""), n = 1; t.includes(r + "_" + n); )
    n += 1;
  return r + "_" + n;
}
function Vt(e, t) {
  var r, n;
  return fe(fe({}, e), {}, {
    label: k(e == null ? void 0 : e.label, t == null || (r = t.map) === null || r === void 0 ? void 0 : r.call(t, function(a) {
      return a.label;
    })),
    value: k(e == null ? void 0 : e.value, t == null || (n = t.map) === null || n === void 0 ? void 0 : n.call(t, function(a) {
      return a.value;
    }))
  });
}
function Qt(e, t) {
  for (var r = [], n = e; n <= t; n++)
    r.push(n);
  return r;
}
function Bt(e, t) {
  if (!(typeof e != "number" && typeof t != "number"))
    return parseFloat(e.toFixed(t));
}
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var t = y;
  Object.keys(t).forEach(function(i) {
    i === "default" || i === "__esModule" || i in e && e[i] === t[i] || Object.defineProperty(e, i, {
      enumerable: !0,
      get: function() {
        return t[i];
      }
    });
  });
  var r = b;
  Object.keys(r).forEach(function(i) {
    i === "default" || i === "__esModule" || i in e && e[i] === r[i] || Object.defineProperty(e, i, {
      enumerable: !0,
      get: function() {
        return r[i];
      }
    });
  });
  var n = re;
  Object.keys(n).forEach(function(i) {
    i === "default" || i === "__esModule" || i in e && e[i] === n[i] || Object.defineProperty(e, i, {
      enumerable: !0,
      get: function() {
        return n[i];
      }
    });
  });
  var a = G;
  Object.keys(a).forEach(function(i) {
    i === "default" || i === "__esModule" || i in e && e[i] === a[i] || Object.defineProperty(e, i, {
      enumerable: !0,
      get: function() {
        return a[i];
      }
    });
  });
  var o = L;
  Object.keys(o).forEach(function(i) {
    i === "default" || i === "__esModule" || i in e && e[i] === o[i] || Object.defineProperty(e, i, {
      enumerable: !0,
      get: function() {
        return o[i];
      }
    });
  });
})(ge);
const Jt = (e, t) => {
  const r = X(e), n = Ce(t);
  B(() => {
    r.current = e;
  }, [e]), B(() => {
    n > 0 && typeof r.current == "function" && r.current();
  }, [n]);
}, Ce = (e) => {
  const t = X(e), [r, n] = $e(0);
  return B(() => {
    ge.isNotEqual(e, t.current) && (t.current = e, n((a) => a + 1));
  }, [e, n]), r;
}, tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useApi: nt,
  useMessenger: pt,
  useOnChange: Jt,
  useOnChangeTrigger: Ce
}, Symbol.toStringTag, { value: "Module" }));
export {
  tr as index,
  nt as useApi,
  pt as useMessenger,
  Jt as useOnChange,
  Ce as useOnChangeTrigger
};
